import { Component, OnInit } from '@angular/core';
import { LacreSituacaoLabels } from '@tivic-team/manager-ts/dist/mob/enums/lacre/lacre-situacao.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
@Component({
  selector: 'dropdown-status-lacre',
  templateUrl: './dropdown-status-lacre.component.html',
  styleUrls: ['./dropdown-status-lacre.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownStatusLacreComponent implements OnInit {

  tipoSituacao = LacreSituacaoLabels;

  constructor() {}

  ngOnInit() {
  }
}
